import React from 'react';
import PropTypes from 'prop-types';
import {gql} from 'apollo-boost';
import {Query} from 'react-apollo';
import {
    AccordionItem,
    AccordionItemTitle,
    AccordionItemBody,
} from 'react-accessible-accordion';
import {filterHeadline, filterHTML} from '../../helpers/filters';
import Paragraph from "../Paragraph";

interface Data {
    paragraphById: {
        fieldTxtHeadline: string;
        fieldTxtSubTitle: string;
        fieldHtmlBody: Array<{
            value: string;
            format: string;
            processed: string;
        }>;
        fieldObjectCtaAccordionItem: Array<{targetRevisionId: string}>;
    }
}

class InnerAccordionItemQuery extends Query<Data, {id: string}> {}

const GET_COMPONENT = gql`
query paragraphById($id: String!) {
  paragraphById:paragraphRevisionById(id: $id) {
    ... on Paragraph {
      ... on Paragraph {
        ... on ParagraphInnerAccordionItem {
          fieldTxtHeadline
          fieldTxtSubTitle
          fieldHtmlBody {
            value
            format
            processed
          }
          fieldObjectCtaAccordionItem {
            targetRevisionId
          }
        }
      }
    }
  }
}
`;

const InnerAccordionItem = ({id, markComponentLoadedAs, handleLoadedComponents}) => (
    <InnerAccordionItemQuery asyncMode query={GET_COMPONENT} variables={{ id }}>
        {({ loading, error, data }) => {
            if (loading) return null;
            if (error) {
                markComponentLoadedAs(id, true);
                return <div>{error}</div>;
            }

            const field = data.paragraphById;

            markComponentLoadedAs(id, true);

            return (
                <AccordionItem className="accordionItem">

                    {field.fieldTxtHeadline && (
                        <AccordionItemTitle>
                            {field.fieldTxtHeadline && (
                                // eslint-disable-next-line react/no-danger
                                <h2 className="accordionItem__title" dangerouslySetInnerHTML={{__html: filterHeadline(field.fieldTxtHeadline)}} />
                            )}
                        </AccordionItemTitle>
                    )}

                    <AccordionItemBody>
                        {field.fieldTxtSubTitle && (
                            // eslint-disable-next-line react/no-danger
                            <h3 className="accordionItem__subtitle" dangerouslySetInnerHTML={{__html: filterHeadline(field.fieldTxtSubTitle)}} />
                        )}

                        {field.fieldHtmlBody && field.fieldHtmlBody.processed && (
                            // eslint-disable-next-line react/no-danger
                            <div className="accordionItemBody">
                                {filterHTML(field.fieldHtmlBody.processed, true)}
                            </div>
                        )}

                        {field.fieldObjectCtaAccordionItem && field.fieldObjectCtaAccordionItem.map(component => (
                            <Paragraph key={`${id}_${component.targetRevisionId}`}
                                       id={String(component.targetRevisionId)}
                                       handleLoadedComponents={handleLoadedComponents}/>
                        ))}

                    </AccordionItemBody>

                </AccordionItem>
            );
        }}
    </InnerAccordionItemQuery>
);

InnerAccordionItem.propTypes = {
    id: PropTypes.number.isRequired,
    markComponentLoadedAs: PropTypes.func.isRequired,
    handleLoadedComponents: PropTypes.func.isRequired
};

export default InnerAccordionItem;



// WEBPACK FOOTER //
// ./frontend/components/Accordion/InnerAccordionItem.jsx